export default {
  data() {
    return {
      list: []
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    // 解密
    async getList() {
      const key = this.$route.query.key; // /app_manage/link_decrypt 旧接口

      const [err, res] = await this.$http.post("/golang/external_sdk_quote/link/decrypt", {
        key: encodeURIComponent(key)
      });
      if (err) return;
      this.list = res.list;
    },

    // 链接跳转
    goUrl(url) {
      window.location.href = url;
    }

  }
};